<template>
  <button :disabled="disabled" @click="disabled ? null : $emit('click')" :class="['xd-button',disabled ? 'disabled' : '' ]">{{text}}</button>
</template>

<script>
export default {
  name: 'XDBUTTON',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: [String, Number],
      default: ''
    },
    click: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="less" scoped>
.xd-button{
  transition: .3s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.xd-button:hover{
  cursor: pointer;
}
.disabled{
  background: #CCCCCC !important;
  border-radius: 5px !important;
  color: #fff !important;
}
</style>
